/**
 * @generated SignedSource<<8c407bdab08b9d1b44384541b017a140>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AnalyticsPanelQuery$variables = {};
export type AnalyticsPanelQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessToGuidelineAnalytics: boolean;
      };
    };
  };
};
export type AnalyticsPanelQuery = {
  response: AnalyticsPanelQuery$data;
  variables: AnalyticsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "hasAccessToGuidelineAnalytics",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "meeting_guidelines_analytics"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"meeting_guidelines_analytics\")"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalyticsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalyticsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "87d27d2487c442d0ec728fee8a5418a0",
    "id": null,
    "metadata": {},
    "name": "AnalyticsPanelQuery",
    "operationKind": "query",
    "text": "query AnalyticsPanelQuery {\n  viewer {\n    account {\n      billingAccount {\n        hasAccessToGuidelineAnalytics: hasAccessToFeature(feature: meeting_guidelines_analytics)\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e248d29a7269eb50ca49f99b78be1037";

export default node;
